export default __webpack_public_path__ + "static/profile-one-be74392027aad9f64b90d513b1161dcb.png";